

import Vue from 'vue'
import App from './App'


import router from './router'
import Api from '@/api'
import axios from '@/common/http'
import store from '@/store'


import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

/*
* Style.css import
*/
import '@/assets/sass/style.scss'
/*
* flexible.js import
*/
import '@/assets/scripts/flexible'
/*
* animate import
*/
import animated from 'animate.css'
Vue.use(animated)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)


Vue.config.productionTip = false
Vue.prototype.$api = Api

/* eslint-disable no-new */
new Vue({
router,
axios,
store,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/main.js